import Swiper, {
  Autoplay,
  Navigation,
  Pagination,
  EffectFade,
  Controller,
} from 'swiper';

class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    const target = this.querySelector('.swiper');
    const data = JSON.parse(this.querySelector('[data-settings]').textContent);

    const bullets = data.customPagination?.customBullets;
    const customPaginationTarget = data.customPagination?.el;

    let customPagination;
    if (bullets && customPaginationTarget) {
      customPagination = {
        pagination: {
          el: customPaginationTarget,
          clickable: false,
          renderBullet(index, className) {
            return `<span class="${className}">${bullets[index]}</span>`;
          },
        },
      };
    }

    if (target && data) {
      const swiper = new Swiper(target, {
        modules: [Autoplay, Navigation, Pagination, EffectFade, Controller],
        ...data,
        ...customPagination,
      });

      this.swiperInstance = swiper;
    } else {
      console.error('No target element or settings provided to SwiperCarousel');
    }
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
      this.swiperInstance = null;
    }
  }
}

export default SwiperCarousel;
